<template>
  <article class="transcript">
    <header>
      <div class="container">
        <h1>{{ transcriptContent.header }} <span>{{ transcriptContent.country }}</span></h1>
        <h2>Transcript</h2>
        <p>Story by:
          <span v-for="(person, index) in transcriptContent.storyBy" :key="index" itemprop="creator" itemscope itemtype="http://schema.org/Person">
            {{ person }}<template v-if="index < transcriptContent.storyBy.length - 2">, </template><template v-if="index === transcriptContent.storyBy.length - 2"> and </template>
          </span>
        </p>
        <p>Narrated by {{ transcriptContent.narrator }}</p>
      </div>
    </header>
    <main>
      <section>
        <div class="container"><p :key="`paragraph-'${index}`" v-for="(paragraph, index) in transcriptContent.transcript">{{ paragraph }}</p></div>
      </section>
    </main>
  </article>
</template>

<script>

export default {
  name: 'SingleTranscript',
  props: {
    // Check type
    transcriptContent: Object,
  }
}
</script>

<style lang="scss">

article.transcript > header {
  padding: 1rem;
  color: $white;
  background-color: $black;
  transition-delay: 0.4s;
  margin-bottom: 1rem;
    h1 {
      margin-top: 2rem;
      @include sm { margin: 0; }
        span {
          font-size: 0.7em;
          font-style: italic;
        }
    }
    h2 {
      margin-top: 0;
    }
    p {
      line-height: 1.5;
    }
}

</style>